import { auth } from "../firebase";
import { isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';
import User from "./User";
import { addObjectToChildArrayAndRefreshCount, removeObjectFromChildArrayAndRefreshCount, updateObjectInChildArrayAndRefreshCount } from "../utils/dbUtils";

class UserNote {
    id = uuid();
    body = null;
    by = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    at = moment().utc().toDate();

    constructor(note) {
        if (isObjectNotEmpty(note)) {
            if (isStringNotEmpty(note.id)) { this.id = note.id; }
            if (isStringNotEmpty(note.body)) { this.body = note.body; }
            if (isStringNotEmpty(note.by)) { this.by = note.by; }
            if (isNotNullOrUndefined(note.at)) { this.at = note.at; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            body: this.body,
            by: this.by,
            at: this.at,
        };
    }

    static addNewNote = (newNote = "", notes = [], at = null, by = null) => {
        let note = new UserNote({ body: newNote, at: at, by: by }).toDto();
        if (isListNotEmpty(notes)) {
            return [...notes, note];
        } else {
            return [note];
        }
    }

    static create = async (userId, note) => {
        let newNote = new UserNote(note).toDto();

        const success = await addObjectToChildArrayAndRefreshCount(User.collectionName, userId, 'notes', 'id', newNote, 'notesCount');
        if (isBooleanTrue(success)) {
            return newNote;
        }

        return null;
    }

    static update = async (userId, note) => {
        let updatedNote = new UserNote(note).toDto();

        const success = await updateObjectInChildArrayAndRefreshCount(User.collectionName, userId, 'notes', 'id', updatedNote, 'notesCount');
        if (isBooleanTrue(success)) {
            return updatedNote;
        }

        return null;
    }

    static remove = async (userId, noteId) => {
        return await removeObjectFromChildArrayAndRefreshCount(User.collectionName, userId, 'notes', 'id', noteId, 'notesCount');
    }
};

export default UserNote;